import React from 'react';
import './BlogOtherEntries.css';

const BlogOtherEntries = (props) => {  
  const blogList  = props.entries;
  const listItems = blogList.map((entry) => 
    <li className="otherEntry" onClick={props.onEntryChange} value={entry.id}>{entry.title}</li>
  ); 

  return (
    <div>
      <div>Other entries</div>
        <ul>{listItems}</ul>
    </div>
  );  
}

export default BlogOtherEntries;
